import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { EmployeesComponent } from './employees.component';
import { ScoresComponent, ScoreInvoicesComponent } from './scores';
import { SalariesComponent } from './salaries';

const employeesRoutes: Routes = [
    {
        path: 'employees',
        component: EmployeesComponent,
        children: [
            {
                path: 'scores',
                component: ScoresComponent
            },
            {
                path: 'salaries',
                component: SalariesComponent
            }
        ]
    }

];

export const employeesRouting: ModuleWithProviders = RouterModule.forChild(employeesRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/employees.routing.ts